import './scoreboard_assist_inventory_form_controller';
import './scoreboard_assist_register_form_controller';
import { NEW_ADMIN_URL } from 'environment';

angular
.module('app.views')
  .config(($routeProvider) => {
      $routeProvider.when('/scoreboard_assists/:id', {
          template: require('./scoreboard_assist.html'),
          controller: 'ScoreboardAssistController'
      });
  })
.controller('ScoreboardAssistController', function($scope, $routeParams, $modal, ScoreboardAssist, Config) {
  $scope.config = Config;
  $scope.newAdminURL = NEW_ADMIN_URL;

  $scope.scoreboardAssist = ScoreboardAssist.get({id: $routeParams.id});

  $scope.canUnregister = scoreboardAssist => !!scoreboardAssist.account_id;

  $scope.canRegister = scoreboardAssist => !scoreboardAssist.account_id;

  $scope.unregister = scoreboardAssist => {
    if (confirm('Are you sure you want to unregister this Scoreboard Assist?')) {
      return ScoreboardAssist.update({id: scoreboardAssist.id, account_id: ''}, data => $scope.scoreboardAssist = data);
    }
  };

  $scope.register = scoreboardAssist => {
    $modal.open({template: require('./scoreboard_assist_register_form.html'), controller: 'ScoreboardAssistRegisterFormController', size: 'lg', backdrop: 'static'}).result.then(sa => $scope.scoreboardAssist = sa);
  }

  $scope.editInventory = scoreboardAssist =>
    $modal.open({template: require('./scoreboard_assist_inventory_form.html'), controller: 'ScoreboardAssistInventoryFormController', size: 'lg', backdrop: 'static'}).result.then(sa => $scope.scoreboardAssist = sa);
  ;
});




// WEBPACK FOOTER //
// ./views/scoreboard_assist/scoreboard_assist_controller.js